import { useNavigate } from "react-router-dom";
import { useSEO } from "../hooks/useSEO";
import { useMobile } from "../hooks/useMobile";
import { serviceList } from "../data/services";
import {
  KAP, Ac, Dugme, Dizin, DizinSatir,
  ALTIN_PARLAK, INK, INK_2, KAGIT, KAGIT_2, CIZGI, DISPLAY, GOVDE,
  BLOK,} from "../components/Ui";

/* =============================================================
   HİZMETLER LİSTESİ

   Eskiden dokuz hizmet dokuz eşit karttı ve her kartın içinde bir
   geometrik ikon vardı. Kart ızgarası dokuz kalemi dokuz kutuya
   bölüp taramayı zorlaştırıyor; burada ana sayfayla AYNI dizin
   düzeni kullanılıyor, böylece iki sayfa aynı dili konuşuyor.
   ============================================================= */

const ETIKET = {
  brand: ["Marka kimliği", "Pazar analizi", "Rekabet stratejisi"],
  ads: ["Google Ads", "Meta Ads", "TikTok Ads", "LinkedIn"],
  production: ["Video", "Senaryo", "Post prodüksiyon"],
  social: ["Instagram", "LinkedIn", "TikTok", "X"],
  trendyol: ["Trendyol", "Hepsiburada", "Amazon TR"],
  mail: ["E-posta", "Lead gen", "İhracat"],
  research: ["Pazar", "Müşteri", "Fiyat"],
  web: ["Web", "E-ticaret", "Landing"],
  seo: ["SEO", "GEO", "AI arama"],
};

export default function ServicesListPage() {
  useSEO({
    title: "Hizmetlerimiz: 9 Alanda Tam Kapsam",
    description: "Marka stratejisi, dijital reklam, sosyal medya, prodüksiyon, SEO, e-ticaret, web tasarım, mail marketing, pazar araştırması. Tek ortakla tam kapsam.",
    path: "/hizmetler",
  });
  const navigate = useNavigate();
  const mobil = useMobile();

  return (
    <div>
      <section style={{
        background: BLOK, color: KAGIT,
        padding: mobil ? "56px 0 64px" : "84px 0 96px",
      }}>
        <div style={KAP}>
          <h1 style={{
            fontSize: mobil ? "clamp(32px,8vw,46px)" : "clamp(38px,5vw,68px)",
            maxWidth: "15ch", color: KAGIT,
          }}>
            Tek ortakla, <span style={{ color: ALTIN_PARLAK }}>tam kapsam.</span>
          </h1>
          <p style={{
            fontFamily: GOVDE, fontSize: mobil ? 16 : 18.5, marginTop: 22,
            color: "rgba(251,250,246,.66)", maxWidth: "52ch", lineHeight: 1.65,
          }}>
            Dokuz hizmet alanı, tek çatı altında. Birden fazla ajansla
            uğraşmak yok, koordinasyon sizin işiniz değil.
          </p>
        </div>
      </section>

      <section style={{ padding: mobil ? "56px 0" : "84px 0" }}>
        <div style={KAP}>
          <Dizin>
            {serviceList.map((s, i) => (
              <Ac key={s.id}>
                <DizinSatir
                  no={String(i + 1).padStart(2, "0")}
                  baslik={s.title.replace(/\s*&\s*/g, " ve ")}
                  aciklama={s.desc}
                  etiketler={ETIKET[s.id] || []}
                  href={`/hizmetler/${s.id}`}
                  onClick={(e) => { e.preventDefault(); navigate(`/hizmetler/${s.id}`); }}
                />
              </Ac>
            ))}
          </Dizin>
        </div>
      </section>

      <section style={{ background: KAGIT_2, padding: mobil ? "56px 0" : "84px 0" }}>
        <div style={{
          ...KAP, display: "grid",
          gridTemplateColumns: mobil ? "1fr" : "1.2fr .8fr",
          gap: mobil ? 26 : 48, alignItems: "center",
        }}>
          <Ac>
            <h2 style={{ fontSize: "clamp(28px,3.4vw,42px)", maxWidth: "17ch" }}>
              Hangisine ihtiyacınız olduğundan emin değil misiniz?
            </h2>
            <p style={{
              fontFamily: GOVDE, fontSize: 16.5, color: INK_2,
              marginTop: 16, maxWidth: "46ch",
            }}>
              Ücretsiz analiz görüşmesinde markanıza bakıp hangi alanın
              önce ele alınması gerektiğini birlikte çıkarıyoruz.
            </p>
          </Ac>
          <Ac gecikme={80} style={{ justifySelf: mobil ? "start" : "end" }}>
            <Dugme href="/iletisim"
                   onClick={(e) => { e.preventDefault(); navigate("/iletisim"); }}>
              Ücretsiz analiz al
            </Dugme>
          </Ac>
        </div>
      </section>
    </div>
  );
}
